<!-- Tags is basically just a wrapper around Word List Input-->
<app-word-list-input
    [items]="tags"
    itemName="Tag"
    [contextClass]="contextClass"
    [typeaheadWords]="savedTags"
    (updated)="updateTags($event)">
</app-word-list-input>